import {
  DESKTOP_BREAKPOINT,
  MOBILE_BREAKPOINT,
} from "../constants/homePageCategory";

export const isDesktop = () => {
  const windowInnerWidth = window.innerWidth;
  return windowInnerWidth >= DESKTOP_BREAKPOINT;
};

export const isMobile = () => {
  const windowInnerWidth = window.innerWidth;
  return (
    windowInnerWidth < DESKTOP_BREAKPOINT &&
    windowInnerWidth > MOBILE_BREAKPOINT
  );
};
